// Grammatica visiva della pagina ordine (redesign 2026-10-22): UN pannello,
// UN titolo, DUE tasti. Prima ogni sezione si scriveva le sue classi a mano e
// la pagina aveva cinque raggi, quattro altezze di tasto e tre stili di titolo.
//
// Leggibilita' (Davide e' dislessico): niente MAIUSCOLETTO nelle etichette —
// le parole tutte maiuscole perdono la sagoma e si leggono lettera per lettera
// — e niente testo sotto gli 11px. Testo sempre NERO (PRODUCT.md, Davide
// 23/09: «deve essere nero così da vedersi facilmente»): la gerarchia la fanno
// taglia e peso, mai il grigio.

/** Il pannello bianco di ogni sezione. Il colore d'area (AREA_CLS) lo aggiunge
 *  il chiamante, come prima. */
export const PANEL =
  "mb-4 rounded-xl border border-line bg-card px-4 py-3.5 shadow-[0_1px_2px_rgba(31,27,22,0.04)]";

/** Titolo di sezione: sans, non serif — a 15px il serif di Source Serif e'
 *  decorativo, e accanto ai numeri tabellari faceva due voci diverse. */
export const TITLE = "text-[15px] font-bold leading-tight text-ink";

/** Il riassunto accanto al titolo («2 righe», «3 colli · 61 kg»). */
export const TITLE_NOTE = "text-[12.5px] font-normal text-ink";

/** Etichetta di campo, in frase normale: peso normale, il valore accanto è in
 *  semigrassetto. */
export const LABEL = "text-[12.5px] font-normal text-ink";

const BTN_BASE =
  "inline-flex min-h-[38px] items-center justify-center gap-1.5 rounded-md border px-3 text-[13px] font-semibold transition-[background-color,border-color,transform] duration-150 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50";

/** Tasto secondario: la maggior parte dei gesti dell'ordine. */
export const BTN = `${BTN_BASE} border-line-2 bg-card text-ink hover:border-ink-4 hover:bg-paper`;

/** Tasto secondario piccolo: per le intestazioni dei pannelli, dove un tasto
 *  alto 38px allungherebbe la riga del titolo. */
export const BTN_SM = BTN.replace("min-h-[38px]", "min-h-[32px]").replace("px-3", "px-2.5");

/** Tasto principale: il passo che fa avanzare l'ordine (Genera LDV). Verde
 *  come prima: Davide lo cerca per colore. */
export const BTN_PRIMARY = `${BTN_BASE} border-emerald-700 bg-emerald-700 text-white hover:border-emerald-800 hover:bg-emerald-800`;

/** Icona dentro un tasto. */
export const BTN_ICON =
  "h-4 w-4 shrink-0 fill-none stroke-current stroke-[1.7] [stroke-linecap:round] [stroke-linejoin:round]";
